import styled from 'styled-components';
import { styledDescriptions, styledTable } from '../../components/styled/mixin';
import { Col, Descriptions, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { ProjectRevenue, projectStatusKorean } from '../../modules/projects';

const StyledDiv = styled.div`
  ${styledDescriptions}
  ${styledTable}
`;

interface RevenueDetailComponentProps {
  projectRevenue: ProjectRevenue;
}

function RevenueDetailComponent({
  projectRevenue,
}: RevenueDetailComponentProps) {
  return (
    <StyledDiv>
      <Row justify="space-between" align="bottom">
        <Col>
          <Title level={3}> 상세</Title>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Descriptions
            title="프로젝트 정보"
            bordered
            column={2}
            size="small"
            style={{ marginTop: '10px' }}
          >
            <Descriptions.Item label="공사명">
              {projectRevenue.name}
            </Descriptions.Item>
            <Descriptions.Item label="발주처">
              {projectRevenue.owner}
            </Descriptions.Item>
            <Descriptions.Item label="상태">
              {projectStatusKorean[projectRevenue.status]}
            </Descriptions.Item>
            <Descriptions.Item label="공사기간">
              {projectRevenue.startDate} ~ {projectRevenue.endDate}
            </Descriptions.Item>
            <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
              {projectRevenue.description}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </StyledDiv>
  );
}

export default RevenueDetailComponent;
